<template>
  <div class="daily-records" role="region" aria-labelledby="daily-records-heading">
    <h2 id="daily-records-heading">每日记录</h2>
    <div class="record-list" aria-live="polite">
      <div v-for="record in records" :key="record.date" class="record-item" role="listitem">
        <span class="date">{{ formatDate(record.date) }}</span>
        <div class="record-info">
          <span class="count">{{ record.count }} 箱</span>
          <ActionButton 
            button-class="delete-btn"
            @click="$emit('delete-record', record)"
            :aria-label="`删除${formatDate(record.date)}的记录`"
          >
            删除
          </ActionButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from './ActionButton.vue';

export default {
  name: 'DailyRecords',
  components: {
    ActionButton
  },
  props: {
    records: {
      type: Array,
      default: () => []
    }
  },
  emits: ['delete-record'],
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }
  }
}
</script>

<style scoped>
.daily-records h2 {
  color: #ffcc00; /* Apex金色文字 */
  margin-bottom: 20px;
  font-size: 1.5rem;
  text-align: center;
  text-shadow: 0 0 5px rgba(255, 204, 0, 0.3);
}

.record-list {
  max-height: 400px;
  overflow-y: auto;
}

.record-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  /* Apex主题记录项背景 */
  background: rgba(26, 13, 45, 0.7);
  border-radius: 10px;
  margin-bottom: 10px;
  transition: all 0.3s ease;
  border-left: 3px solid #667eea; /* 左侧蓝色边框 */
}

.record-item:hover {
  background: rgba(26, 13, 45, 0.9);
  transform: translateX(5px);
  box-shadow: 0 0 10px rgba(102, 126, 234, 0.5);
}

.date {
  font-weight: bold;
  color: #ffcc00; /* Apex金色日期 */
  text-shadow: 0 0 3px rgba(255, 204, 0, 0.3);
}

.record-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.record-item .count {
  font-size: 1.2rem;
  margin: 0;
  color: #667eea; /* Apex蓝色数字 */
  font-weight: bold;
  text-shadow: 0 0 5px rgba(102, 126, 234, 0.3);
}

/* 移动端适配 */
@media (max-width: 768px) {
  .record-item {
    padding: 12px 15px;
    margin-bottom: 8px;
  }
  
  .date {
    font-size: 0.9rem;
  }
  
  .record-item .count {
    font-size: 1rem;
  }
}

/* 小屏幕适配 */
@media (max-width: 480px) {
  .record-item {
    flex-direction: row;
    text-align: left;
    gap: 0;
  }
  
  .date {
    font-size: 0.85rem;
  }
  
  .record-item .count {
    font-size: 0.9rem;
  }
}
</style>